<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_326" data-name="Group 326" transform="translate(-35.342 -280.286)">
    <circle id="Ellipse_50" data-name="Ellipse 50" cx="35.201" cy="35.201" r="35.201" transform="translate(35.342 280.286)" fill="#fff"/>
    <path id="Path_84" data-name="Path 84" d="M2362.176,1171.164a13.288,13.288,0,1,1-13.288-13.289,13.29,13.29,0,0,1,13.288,13.289" transform="translate(-2267.717 -850.394)" fill="#1a1818"/>
    <path id="Path_85" data-name="Path 85" d="M2340.751,1171.3l5.781,5.781,10.492-10.492" transform="translate(-2267.717 -850.394)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/>
    <path id="Path_86" data-name="Path 86" d="M2334.153,1164.025l-4.757-4.939-5.9,5.68-2.082-2.16,5.9-5.681-5.68-5.9,2.16-2.08,5.68,5.9,5.9-5.679,2.082,2.16-5.9,5.68,4.209,4.371a16.422,16.422,0,0,1,6.9-5.371,13.278,13.278,0,1,0-13.232,14.249,13.12,13.12,0,0,0,3.129-.393A16.247,16.247,0,0,1,2334.153,1164.025Z" transform="translate(-2267.717 -850.394)" fill="#1a1818"/>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_04_02',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_04_02.vue